<template>
<div style="display: contents;" >
 
  <tr v-bind:key="rate.id" v-for="rate in ratesgas" class="trclass" :class="{'font-weight-bold': isBold(rate)}">
    <td width="10%" :class="{'font-italic': isItalic(rate)}">{{nameColumn(rate)}} {{ handleChargeGridName(rate) }}</td>
    <td>{{basedOnColumn(rate)}}</td>
    <td style="white-space: nowrap">{{rateColumn(rate)}}</td>
    <td class="text-right">{{ $n(perMonthColumn(rate), 'currency', 'nl-NL') }}</td>
    <td class="text-right">{{ $n(perYearColumn(rate), 'currency', 'nl-NL') }}</td>
  </tr>

  <!-- total gas amounts -->
  <tr class="trclass font-weight-bold">
    <td width="10%">
      {{ translate[lang]["totalcost"] }} {{ name }}
    </td>
    <td></td>
    <td style="white-space: nowrap"></td>
    <td class="text-right">{{ $n(perMonthTotal(), 'currency', 'nl-NL') }}</td>
    <td class="text-right">{{ $n(perYearTotal(), 'currency', 'nl-NL') }}</td>
  </tr>

</div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "RatesTableTrGas",
  props: ["proposition", "name"],
  data() {
    return {
      ratesgas: {},
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      combinations: (state) => state.forms.combinations,
      solar: (state) => state.forms.solar,
      solars: (state) => state.forms.solars,
      consumption: (state) => state.forms.consumption,
      ratesloader: (state) => state.forms.ratesloader,
      meter: (state) => state.forms.meter,
      addressResidential: (state) => state.forms.addressResidential,
      postcodeQuery: (state) => state.forms.postcodeQuery
    }),
  },
  methods: {
    ...mapMutations({
      setTotal: "forms/SET_GAS_TOTAL",
    }),

    handleChargeGridName(item) {

      if (item.field == "gas_charge_grid_operation") {
        let gasConsumption = parseInt(this.consumption.gas);
        if (
            this.postcodeQuery &&
            this.postcodeQuery.network_operators["G"] &&
            !this.postcodeQuery.error
        ) {
          let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
          if (postCodeGasOperators) {
            if (500 > gasConsumption) {
              return (
                  " (" +
                  postCodeGasOperators.filter(
                      (x) => x.connection_value == "G6 < 500 m3"
                  )[0].name +
                  ")"
              );
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              return (
                  " (" +
                  postCodeGasOperators.filter(
                      (x) => x.connection_value == "G6 < 4000 m3"
                  )[0].name +
                  ")"
              );
            } else if (gasConsumption >= 4000) {
              return (
                  " (" +
                  postCodeGasOperators.filter(
                      (x) => x.connection_value == "G6 >= 4000 m3"
                  )[0].name +
                  ")"
              );
            }
          }
        }
      }
      return "";
    },

    getRates() {
      var rates = this.overview.find(x => x.group === 'gas').rates;
      
      // The rates listed below are ordered in line with the table requirements
      this.ratesgas = {
        0: rates.find(x => x.proposition_id === this.proposition && x.field === 'usage_gas'),
        1: rates.find(x => x.proposition_id === this.proposition && x.field === 'supply_gas'),
        2: rates.find(x => x.proposition_id === this.proposition && x.field === 'ode_gas'),
        3: rates.find(x => x.proposition_id === this.proposition && x.field === 'gas_fixed_charge_of_supply'),
        4: rates.find(x => x.proposition_id === this.proposition && x.field === 'gas_charge_grid_operation'),
      }

      this.setTotal(this.perYearTotal());
    },

    // determine if the rate should display days or m3
    rateType(rate) {
      if (rate.field == 'gas_fixed_charge_of_supply' || rate.field == 'gas_charge_grid_operation') {
        return this.translate[this.lang]["ratesTableDay"];
      } else {
        return 'm3';
      }
    },

    // determine if the row has to be bold
    isBold(rate) {
      if (rate.field == 'supply_gas' || rate.field == 'ode_gas') {
        return false;
      }
      return true;
    },

    nameColumn(rate) {
      if (this.lang == 'en') {
        return JSON.parse(rate.name).en;
      } else {
        return JSON.parse(rate.name).nl;
      }
    },

    // determine if the row has to be italic
    isItalic(rate) {
      if (rate.field == 'supply_gas' || rate.field == 'ode_gas') {
        return true;
      }
      return false;
    },

    basedOnColumn(rate) {
      if (rate.field == 'return_delivery') {
        return this.solar.single - this.consumption.gas + ' m3';
      } else {
        return (this.rateType(rate) == 'm3') ? ((this.consumption.gas > 0) ? this.consumption.gas : 0) + ' m3' : this.translate[this.lang]["365days"];
      }
    },

    // parse the value of the rate column
    rateColumn(rate) {

      if (this.rateType(rate) === 'm3') {
        return this.$n(rate.rate, 'currency', 'nl-DC') + ' / ' + 'm3';
      } else {

        if (
            rate.field == 'gas_charge_grid_operation' &&
            this.postcodeQuery &&
            this.postcodeQuery.network_operators["G"] &&
            !this.postcodeQuery.error
        ) {

          let gasConsumption = parseInt(this.consumption.gas);
          let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
          let dayPrice = 0
          if (postCodeGasOperators) {
            if (500 > gasConsumption) {
              dayPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 500 m3"
              )[0].daily.replace(",", ".")
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              dayPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 4000 m3"
              )[0].daily.replace(",", ".")
            } else if (gasConsumption >= 4000) {
              dayPrice = postCodeGasOperators.filter(
                      (x) => x.connection_value == "G6 >= 4000 m3"
                  )[0].daily.replace(",", ".")
            }

            return this.$n(dayPrice, 'currency', 'nl-DC') + ' / ' + this.translate[this.lang]["365days"];

          }
        } else {
          return this.$n(rate.rate, 'currency', 'nl-DC') + ' / ' + this.translate[this.lang]["365days"];
        }

      }
    },

    // parse the value of the `per month` column
    perMonthColumn(rate) {
      if (this.rateType(rate) === 'm3') {
        return parseFloat(this.consumption.gas * rate.rate / 12).toFixed(2);
      } else {

        if (
            rate.field == 'gas_charge_grid_operation' &&
            this.postcodeQuery &&
            this.postcodeQuery.network_operators["G"] &&
            !this.postcodeQuery.error
        ) {
          let gasConsumption = parseInt(this.consumption.gas);
          let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
          let monthPrice = 0
          if (postCodeGasOperators) {
            if (500 > gasConsumption) {
              monthPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 500 m3"
              )[0].monthly.replace(",", ".")
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              monthPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 4000 m3"
              )[0].monthly.replace(",", ".")
            } else if (gasConsumption >= 4000) {
              monthPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 >= 4000 m3"
              )[0].monthly.replace(",", ".")
            }

            return parseFloat(monthPrice).toFixed(2);

          }
        } else {
          return parseFloat((365 * rate.rate) / 12).toFixed(2);
        }


      }
    },

    // parse the value of the 'per year' column
    perYearColumn(rate) {

      if (this.rateType(rate) === 'm3') {
        return parseFloat(this.consumption.gas * rate.rate).toFixed(2);  
      } else {

        if (
            rate.field == 'gas_charge_grid_operation' &&
            this.postcodeQuery &&
            this.postcodeQuery.network_operators["G"] &&
            !this.postcodeQuery.error
        ) {
          let gasConsumption = parseInt(this.consumption.gas);
          let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
          let yearlyPrice = 0

          if (postCodeGasOperators) {
            if (500 > gasConsumption) {
              yearlyPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 500 m3"
              )[0].yearly.replace(",", ".")
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              yearlyPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 < 4000 m3"
              )[0].yearly.replace(",", ".")
            } else if (gasConsumption >= 4000) {
              yearlyPrice = postCodeGasOperators.filter(
                  (x) => x.connection_value == "G6 >= 4000 m3"
              )[0].yearly.replace(",", ".")
            }

            return parseFloat(yearlyPrice).toFixed(2);

          }
        } else {
          return parseFloat(365 * rate.rate).toFixed(2);
        }

      }
    },

    perMonthTotal() {
      return (this.perYearTotal() / 12).toFixed(2);
    }, 

    perYearTotal() {
      var total = 0;

      var usage_gas = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'usage_gas').rate * this.consumption.gas;
      total += usage_gas;
      var fixed_charge = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'gas_fixed_charge_of_supply').rate * 365;
      total += fixed_charge;
      var grid_charge = this.overview.find(x => x.group === 'gas').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'gas_charge_grid_operation').rate * 365;

      if(
          this.postcodeQuery &&
          this.postcodeQuery.network_operators["G"] &&
          !this.postcodeQuery.error
      ) {

        let gasConsumption = parseInt(this.consumption.gas);
        let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
        let yearlyPrice = 0

          if (500 > gasConsumption) {
            yearlyPrice = postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 < 500 m3"
            )[0].yearly.replace(",", ".")
          } else if (500 <= gasConsumption && gasConsumption < 4000) {
            yearlyPrice = postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 < 4000 m3"
            )[0].yearly.replace(",", ".")
          } else if (gasConsumption >= 4000) {
            yearlyPrice = postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 >= 4000 m3"
            )[0].yearly.replace(",", ".")
          }

          total += parseFloat(yearlyPrice);

      } else {

        total += grid_charge;

      }

      return total.toFixed(2);
    }
  },
  created() {
    this.getRates();
  },
  watch: {
    consumption: {
      handler: function () {
        this.getRates();
      },
      deep: true,
    },
    itemRates() {
      this.getRates();
    },
    form: {
      handler: function () {
        this.getRates();
      },
      deep: true,
    },
    solar: {
      handler: function () {
        this.getRates();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
